import React, { Fragment, Component } from 'react';
import { withTranslation } from 'react-i18next';
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import {
    LanguageSwitcher,
    Loading,
    GelContentContainer,
    Form,
    FormProgress,
    NotFound
} from 'cw-styleguide-react';
import i18n from '../i18n';
import { route, routeTranslated } from '../routes';
import Animal from '../components/Animal';
import GaHelmet from '../components/GaHelmet';

class ResultsView extends Component {
  render() {
    if (!this.props.animal) {
      return <Loading />;
    }
      if (![this.props.t('results.tabs.personality.slug'),  this.props.t('results.tabs.job.slug'), this.props.t('results.tabs.education.slug')  ].includes(this.props.params.tab)) {
          return <GelContentContainer><NotFound/></GelContentContainer>
      }
      console.log('PARAMS',this.props.params);
    return (
      <Fragment>
        <GaHelmet>
          <title>{this.props.t('route_results_title')} | {this.props.t('route_app_title')}</title>
        </GaHelmet>
        <LanguageSwitcher to={routeTranslated('result', { tab: this.props.t('results.tabs.personality.slug', { lng: i18n.language === 'en' ? 'cy' : 'en' }) })} />
        <BreadcrumbsItem to={route('result', { tab: this.props.t('results.tabs.personality.slug') })}>
          {this.props.t('route_results_title')}
        </BreadcrumbsItem>
        <GelContentContainer>
          <h1>{this.props.t('results.title')}</h1>
          <Form theme={['no-padding', 'no-background']}>
            <FormProgress steps={[
              { title: this.props.t('route_step1_title'), to: route('step1'), buttonTitle: this.props.t('route_step1_title') },
              { title: this.props.t('route_step2_title'), to: route('step2'), buttonTitle: this.props.t('route_step2_title') },
              { title: this.props.t('route_step3_title'), to: route('step3'), buttonTitle: this.props.t('route_step3_title') },
              { title: this.props.t('route_step4_title'), to: route('step4'), buttonTitle: this.props.t('route_step4_title') },
              { title: this.props.t('route_results_title'), to: route('result', { tab: this.props.params.tab }), buttonTitle: this.props.t('route_results_title') }
            ]} />
          </Form>
          <Animal animal={this.props.animal} resetAnswers={this.props.resetAnswers} baseRoute={route('results')} />
        </GelContentContainer>
      </Fragment>
    );
  }
}


export default withTranslation('local')(ResultsView);
